'use strict'

import { Enum } from './enums'

const DiseasedStrainStateEnum = new Enum({
  UNPREDICTED: { value: 2147483647, summary: '未预测', summaryEn: 'unpredicted' },
  NORMAL: { value: 1, summary: '不会出现', summaryEn: 'notSatisfied' },
  ONCOMING: { value: 2, summary: '接近', summaryEn: 'closeToSatisfy' },
  MATCHING: { value: 3, summary: '达到', summaryEn: 'satisfied' }
})

export { DiseasedStrainStateEnum }



// WEBPACK FOOTER //
// ./src/utils/DiseasedStrainStateEnum.js